import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {

    setGeoLoactionStateAction,
    setZoneActions,
    setRegionActions,
    settheTicketIDSActions,
    settheTicketsystemrecordgetListInternalNearDueDataActions,
    settheTicketraiseroutes,

} from "../../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import { parseISO, addDays, differenceInDays } from "date-fns";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
import Swal from "sweetalert2";
import _ from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import useDebouncedEffect from 'use-debounced-effect';



const NearDueListed = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const state = useSelector((state) => state);
    const [currentPage, setCurrentPage] = useState(1);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(20);
    const [search, setsearch] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [DeletePOPUP, setDeletePOPUP] = useState(false);
    const [DeleteID, setDeleteID] = useState("");
    const [EditId, setEditID] = useState();
    const navigate = useNavigate()
    const FileterState = {
        // status: state.StateManagementOverallCall.TicketsStatusState?.value,
        status: state.SideBarFiles.NearDueStatusFilterDepartment?.value,
        priority: state.ClientBranchIDs.InernalTicketList_Priority?.value,
    };

    const [selectVal, SetSelectval] = useState(FileterState);


    const [StatusTicket, setstatustcket] = useState(state.SideBarFiles.NearDueStatusFilterDepartment)
    const [FState, SetStates] = useState(false);


    // console.log(state.ClientBranchIDs.InernalDashboardTicketSystem_Status, StatusTicket, "state.StateManagementOverallCall.TicketsStatusState");

    ////--_FIlter--------------------------
    const [Filter, SetFilter] = useState(true);
    const [TracketReport, setTicketReport] = useState({
        OpenTicket: 2,
        Closeticker: 3,
        PendingTickets: 4,
    });

    const optionsstatus = [
        { value: "", label: "All" },

        { value: "0", label: "Open" },
        { value: "1", label: "In Progress" },
        { value: "2", label: "Review" },
        { value: "over_due", label: "Over Due" },
        { value: "3", label: "Resolved" },

        { value: "4", label: "Reopened" },

    ];

    let priorityoptions = [
        { value: "", label: "All" },
        { value: "0", label: "Low" },
        { value: "1", label: "Medium" },
        { value: "2", label: "High" },
    ];
    const [PriorityValues, setPriorityValues] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Priority)




    const [multiselect1, setMuliselect1] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_Region,]);
    const [multiselect3, setMuliselect3] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_Zone,]);
    const [nameList5, setOptions5] = useState([]);

    const [datas, setData] = useState({
        zone: state.ClientBranchIDs.InernalDashboardTicketSystem_Zone?.value,
        state: state.ClientBranchIDs.InernalDashboardTicketSystem_State?.value,
        region: state.ClientBranchIDs.InernalDashboardTicketSystem_Region?.value,
    });
    const [multiselect, setMuliselect] = useState([state.ClientBranchIDs.InernalDashboardTicketSystem_State,]);
    ///--filter----------------
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);


    ///----Filter-----------------------

    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
    const [SttausValues, setStatusValue] = useState(state.ClientBranchIDs.InernalDashboardTicketSystem_Status?.value);


    const initialDebouanceSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


    useEffect(() => {
        dispatch(settheTicketraiseroutes(3))
    }, [])

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };

    useEffect(() => {
        const payload = {
            search: search,
            page_size: 20,
            page: 1,
            state: datas.state,
            zone: datas.zone,
            region: datas.region,
            // client: Client,
            priority: selectVal.priority,
            status: selectVal.status =="over_due" ? "": selectVal.status,
            ticket_assign: true,
            over_due:selectVal.status =="over_due" ? true :""
        };
        dispatch(settheTicketsystemrecordgetListInternalNearDueDataActions(payload));

    }, [dtpageindex, selectVal.status, selectVal.priority, search, datas]);

    console.log(SttausValues, "SttausValues");

    ///--------------State-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    //--------------_Zone---------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.zoneSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            region_id: datas.region,
        };
        dispatch(setZoneActions(payloads));
    }, [datas.region, SearchedVal.zoneSearch]);

    //-----Region---------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1, //-----only we ----get----the----selected regions , the--id only
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);





    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.GeoState.State.forEach((element) => {
                objectArray.push({ value: element.id, label:capitalizeEachWord( element.state_name.toLowerCase() )});
            });

            // console.log(objectArray , "objectArray");
            setOptions(objectArray);
        }
    }, [state.GeoState.State, SearchedVal.stateSearch]);


    ///  ///----------------------REgion-----------
    useEffect(() => {
        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.region_name.toLowerCase()) });
            });

            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);


    //----Region----------------
    const handelRegionSlect = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect1(selectedVal);
            setMuliselect3({ value: "", label: "All" });

            setData({
                ...datas,
                region: selectedVal.value,
            });
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                region: "",
                zone: "",
            });

            setMuliselect3({ value: "", label: "All" });
            setMuliselect1({ value: "", label: "All" });
        }
    };
    //----------------Zone
    const handleZone = (selectedVal) => {
        //console.log(selectedVal ,"selected Values");
        if (selectedVal != null) {
            setMuliselect3(selectedVal);
            setData({
                ...datas,
                zone: selectedVal.value,
            });
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                zone: "",
            });
            setMuliselect3({ value: "", label: "All" });
        }
    };
    const handleSelectChange = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect(selectedVal);
            setMuliselect1({ value: "", label: "All" });
            setMuliselect3({ value: "", label: "All" });

            setData({
                ...datas,
                state: selectedVal.value,
                zone: "",
                region: "",
            });

        }
        if (selectedVal == null) {
            setMuliselect({ value: "", label: "All" });
            setMuliselect1({ value: "", label: "All" });
            setMuliselect3({ value: "", label: "All" });
            setData({
                ...datas,
                state: "",
                zone: "",
                region: "",
            });


        }

    };
    ///-------------Zone--------------
    useEffect(() => {
        if (state.ZonePart.Zone != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.zone_name.toLowerCase()) });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);



    useEffect(() => {
        if (state.TrackingrecordgetList.TrackingReport) {
            const Options = {
                OpenTicket:
                    state.TrackingrecordgetList.TrackingReport.open_tracking_count,
                Closeticker:
                    state.TrackingrecordgetList.TrackingReport.close_tracking_count,
                PendingTickets:
                    state.TrackingrecordgetList.TrackingReport.pending_tracking_count,
            };
            setTicketReport(Options);
        }
    }, [state.TrackingrecordgetList.TrackingReport]);



    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };


    const HandlethepriorityChanges = (e) => {
if(e != null ){
            setPriorityValues(e);
        SetSelectval({
            ...selectVal,
            priority: e.value
        })
}
else {
             setPriorityValues(null);
        SetSelectval({
            ...selectVal,
            priority: ""
        })
}
    }


    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    stateSearch: SearchDebounance.stateSearch,
                    regionSearch: SearchDebounance.regionSearch,
                    zoneSearch: SearchDebounance.zoneSearch,
                });
            }
        },
        500,
        [SearchDebounance]
    );
    

///-----State----Input Changes
const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};




    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);



    const getIconColor = (createdAt, expireTime) => {
        // Convert expireTime to an integer
        const expireDays = parseInt(3);

        // Calculate the expiration date by adding expireDays to createdAt
        const expirationDate = addDays(createdAt, expireDays);

        // Calculate the difference in days between expiration date and current date
        const daysDifference = differenceInDays(expirationDate, new Date());

        // Log the difference in days for debugging
        console.log(daysDifference, "daysDifference", expirationDate, expireDays);

        // Determine the color based on the difference in days
        if (daysDifference < 0 || daysDifference == 0) {
            return "red"; // Expired, set color to red
        }
        // else if (daysDifference <= 2) {
        else if (daysDifference == 2) {
            // return "yellow"; // Expiring within 7 days, set color to yellow
            return "green";
        } else if (daysDifference == 1) {
            return "red"; // Not expiring soon, set color to green
        }
    };



    const capitalizeEachWord = (str) => {
        return str
            .split(' ') // Split the string into an array of words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back into a string
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };

    function overdueFunctionspercentanges(item) {
        console.log(item, "sadiuasidu item");

        const overdueMinutes = (item / 100);

        return overdueMinutes;

    }


    const overdueFunctions = (ticketretrieve) => {
        const convertToMinutes = (days, hours, minutes) => (days * 24 * 60) + (hours * 60) + minutes;
        let differenceInMinutes

        function calculateTimeStatus(differenceInMinutes) {
            console.log(differenceInMinutes, 'differenceInMinutes');

            if (differenceInMinutes > 0 || differenceInMinutes == 0) {
                return "Overdue";
            }

            if (Math.abs(differenceInMinutes) >= 1440) {
                // More than or equal to 1 day
                const days = Math.floor(Math.abs(differenceInMinutes) / (60 * 24));
                return `${days} Days left`;
            }

            if (Math.abs(differenceInMinutes) >= 60) {
                // More than or equal to 1 hour
                const hours = Math.floor(Math.abs(differenceInMinutes) / 60);
                return `${hours} Hours left`;
            }

            // Less than 1 hour
            const minutes = differenceInMinutes * -1;
            return `Minutes left ${minutes}`;
        }
        var remainingTimevalues


        const formatTime = (ms) => {
            const days = Math.floor(ms / (1000 * 60 * 60 * 24));
            const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            return { days, hours, minutes };
        };

        const formatTimeLevel = (ms, Levelonbetypes) => {
            return {
                days: Levelonbetypes === "2" ? ms : 0,
                hours: Levelonbetypes === "1" ? ms : 0,
                minutes: Levelonbetypes === "0" ? ms : 0,
            };
        };

        if (ticketretrieve?.created_at && ticketretrieve?.department_users?.l1_user_TAT) {
            const createdDate = new Date(ticketretrieve.created_at);
            const currentDate = new Date();
            const differenceInMs = currentDate - createdDate;

            const timeDifference = formatTime(differenceInMs);

            const LevelonbeTAT = Number(ticketretrieve.department_users.l1_user_TAT);
            const Levelonbetypes = ticketretrieve.department_users.l1_time_type;

            const period1Minutes = convertToMinutes(
                timeDifference.days,
                timeDifference.hours,
                timeDifference.minutes
            );

            const period2Minutes = convertToMinutes(
                Levelonbetypes === "2" ? LevelonbeTAT : 0,
                Levelonbetypes === "1" ? LevelonbeTAT : 0,
                Levelonbetypes === "0" ? LevelonbeTAT : 0
            );

            differenceInMinutes = period1Minutes - period2Minutes;
            remainingTimevalues = calculateTimeStatus(differenceInMinutes);
            console.log(differenceInMinutes, " asdasdasd differenceInMnutes", differenceInMinutes > 0, remainingTimevalues);
            // Convert the difference back to days, hours, and minutes
            // Debugging log




            overdueFunctionspercentanges(differenceInMinutes * -1)

            return remainingTimevalues
        }

        return remainingTimevalues


    };





    const columns = [
        {
            Header: "Ticket Number",
            accessor: "",
            Cell: ({ row }) => {
                const userId = row.original.id;
                const lastFourDigits = userId ? userId.toString().slice(-6) : "---";
                const originalString = row.original.status;
                const ticketnum = row.original.ticket_number;

                const createdAt = row.original.created_at
                    ? parseISO(row.original.created_at)
                    : null;
                const expireTime = row.original.sub_category_id?.TAT
                    ? row.original.sub_category_id.TAT
                    : null;
                // const expireTime = true ? 3 : null;
                const iconColor =
                    createdAt && expireTime
                        ? getIconColor(createdAt, expireTime)
                        : "grey"; // Default color if dates are not available

                return (
                    <>
                        {userId ? (
                            <span
                                style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center", width: "107px" }}
                            >
                                {ticketnum}

                            </span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },
        {
            Header: "Created Date",
            accessor: "created_at",
            Cell: (row) => {
                const dateString = row.row.original.created_at;
                const dateObject = new Date(dateString);
                const hours = dateObject.getHours();
                const minutes = dateObject.getMinutes();
                const seconds = dateObject.getSeconds();
                const amOrPm = hours >= 12 ? "PM" : "AM";
                const twelveHourFormat = hours % 12 || 12;

                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                return (
                    <>
                        <div className="CreatedDatelisted">
                            {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at) : ""}
                        </div>
                    </>
                );
            },
        },


        {
            Header: "Departments",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.department_id?.department_name ?
                            capitalizeEachWord(data.department_id?.department_name.toLowerCase()) :
                            "-"

                        }</p>
                    </div>
                );
            },
        },
        {
            Header: "Category",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.internal_category_id?.issue_category_id?.name ?
                            capitalizeEachWord(data.internal_category_id?.issue_category_id?.name.toLowerCase()) : "-"}</p>
                    </div>
                );
            },
        },

        {
            Header: "Subcategory",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.internal_category_id?.name ?
                            capitalizeEachWord(data.internal_category_id?.name.toLowerCase()) : "-"}</p>
                    </div>
                );
            },
        },

        {
            Header: "Priority",
            accessor: "Priority",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                // Priority colors
                const priorityColor = data?.priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data?.priority === "0" || data?.priority === "1" || data?.priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"

                                }}
                            >
                                {data?.priority === "0" ? "Low" : data?.priority === "1" ? "Medium" : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },
        {
            Header: "QPMS Criticality",

            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                // Sub-category priority colors
                const priorityColor = data?.internal_category_id?.Priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.internal_category_id?.Priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.internal_category_id?.Priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data.internal_category_id?.Priority === "0" || data.internal_category_id?.Priority === "1" || data.internal_category_id?.Priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"
                                }}
                            >
                                {data.internal_category_id?.Priority === "0"
                                    ? "Low"
                                    : data.internal_category_id?.Priority === "1"
                                        ? "Medium"
                                        : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },



        {
            Header: "Status",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="TicketButtons">

                        <>
                            <button className='Buttonstatus'
                                style={{
                                    background: data.status == 0 ? "#FDEDE9" : // Open - light background
                                        data.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                            data.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                data.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                    "#FFDDDD", // Default for Reopen - light red background
                                    color: data.status == 0 ? "#ed4c28" : // Open - red text
                                        data.status == 1 ? "#FFB800" : // In Progress - yellow text
                                            data.status == 2 ? "#12B749" : // Completed - green text
                                                data.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                    "#ed4c28", // Default for Reopen - red text
                                }}
                            >
                                {data.status == 0 ? "Open" :
                                    data.status == 1 ? "In Progress" :
                                        data.status == 2 ? "Review" :
                                            data.status == 3 ? "Resolved" : "Reopened"}


                            </button>

                        </>

                    </div>
                );
            },
        },

        {
            Header: "Due",
            accessor: "",
            Cell: ({ cell }) => {
                let item = cell.row.original;
                return (
                    <div className="TicketButtons TicketNearDue">

                        <>

                            <p className="HeaderoftheDatefileds Dashboardneardues">


                                {overdueFunctions(item) != "Overdue" ?
                                    <Stack spacing={2} direction="row">
                                        <CircularProgress variant="determinate"


                                            value={
                                                (() => {
                                                    const response = overdueFunctions(item); // Get the response
                                                    let percentage = 0; // Default to 0


                                                    if (response && response.includes("Minutes left")) {
                                                        const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                        // Extract the remaining time from the text (in minutes)
                                                        const minutesLeft = Number(rest.join(""));
                                                        const totalTAT = item?.department_users?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                        // console.log(minutesLeft, typeof minutesLeft, isNaN(minutesLeft), "oasiudopasidopaisd minutesLeft", totalTAT, minutesLeft, Math.min((minutesLeft / totalTAT) * 100, 100));


                                                        // Ensure the minutesLeft is a valid number
                                                        if (isNaN(minutesLeft)) {
                                                            console.error("Invalid minutesLeft value:");
                                                            return percentage; // Return 0 if invalid
                                                        }


                                                        if (isNaN(totalTAT)) {
                                                            console.error("Invalid totalTAT value:", totalTAT);
                                                            return percentage; // Return 0 if invalid
                                                        }
                                                        if (totalTAT === 1) {
                                                            // Directly use minutesLeft as a percentage of 100
                                                            percentage = Math.min(minutesLeft, 100);
                                                        } else {
                                                            // Use the usual percentage formula
                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                        }

                                                        // percentage = Math.min((minutesLeft / totalTAT ) * 100, 100);
                                                    }
                                                    else if (response && response.includes("Hours left")) {
                                                        const [minutesText, ...rest] = response.split("Hours left");
                                                        const minutesLeft = parseInt(minutesText.trim(), 10);

                                                        if (isNaN(minutesLeft)) {
                                                            console.error("Invalid minutesLeft value:", minutesLeft);
                                                            return percentage; // Return 0 if invalid
                                                        }

                                                        const totalTAT = item?.department_users?.l1_user_TAT || 100;
                                                        if (isNaN(totalTAT)) {
                                                            console.error("Invalid totalTAT value:", totalTAT);
                                                            return percentage; // Return 0 if invalid
                                                        }

                                                        percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                    }

                                                    else if (response && response.includes("Days left")) {
                                                        const [minutesText, ...rest] = response.split("Days left");
                                                        const minutesLeft = parseInt(minutesText.trim(), 10);
                                                        if (isNaN(minutesLeft)) {
                                                            console.error("Invalid minutesLeft value:", minutesLeft);
                                                            return percentage; // Return 0 if invalid
                                                        }

                                                        const totalTAT = item?.department_users?.l1_user_TAT || 100;
                                                        if (isNaN(totalTAT)) {
                                                            return percentage;
                                                        }
                                                        percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                    }

                                                    console.log(percentage, "aspdopasidoasd percentage", response);

                                                    return percentage;
                                                })()
                                            }
                                            style={{
                                                borderRadius: "50%",
                                                width: "59px",
                                                height: "59px",
                                                background: "transparent", // Conditional background color based on the value
                                                borderColor: "#234492",
                                                color: "#234492",
                                                marginRight: "-16px !important"
                                            }}

                                            sx={{
                                                borderRadius: "50%",
                                                width: "55px",
                                                height: "55px",
                                                backgroundColor: "transparent", // Conditional background color
                                                // border: "2px solid", // Border width
                                                borderColor: 90 === 90 ? "#234492" : "gray", // Conditional border color
                                            }}
                                        />

                                        <span className="HeaderoftheDatefiledsNameDashboard">
                                            {(() => {
                                                const response = overdueFunctions(item); // Get the response

                                                if (response) {
                                                    // Check for specific time-related keywords
                                                    if (response.includes("Minutes left")) {
                                                        const [minutesText, ...rest] = response.split("Minutes left"); // Split the response

                                                        return <> <span>{rest.join("")}</span><span className="MinutesLeft">

                                                            {"Minutes"}</span></>


                                                    } else if (response.includes("Hours left")) {
                                                        const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                        const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                        return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                            {"Hours"}</span></>
                                                    } else if (response.includes("Days left")) {
                                                        const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                        const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                        return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                            {"Days"}</span></>

                                                    } else if (response === "Overdue") {
                                                        return <span className="OverdueText">Overdue</span>;
                                                    }
                                                }

                                                return null; // Render nothing if response is not defined
                                            })()}

                                        </span>
                                    </Stack>
                                    :
                                    <span className="OverdueText">Overdue</span>}


                            </p>

                        </>

                    </div>
                );
            },
        },

    ];

    const ClearState = (Counts) => {
        if (Counts == 2) {
            SetSelectval({
                ...selectVal,
                status: "",
            });
            setstatustcket({ value: "", label: "All" })
            setdtPageindex(1);
        }
    };

    //--------_____Filter-----------Based---On----Status--
    const count = (Counts, values, sel, SelectedValues) => {
        setdtPageindex(1);
        // setSelected(sel);
        SetStates(true);
        setstatustcket(SelectedValues)
        SetSelectval({
            ///Completed
            ...selectVal,

            status: sel,
        });

    };



    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);

        }
    };


    const HandleTicketViewparts = (data) => {

        setTimeout(() => {
            dispatch(settheTicketraiseroutes(3))
            dispatch(settheTicketIDSActions(data.id)); /// ticket id
        }, 30);
        navigate("/internal_ticketview")


    }


    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3>Near Due</h3>

                    </div>


                </div>


                <div
                    className="row Filters ButtonPrevious"
                    style={{
                        padding: "15px 28px",
                        margin: "0px",
                        position: "relative",
                        zIndex: "30",

                        marginLeft: "0px",
                        marginRight: "0px",
                        top: "-30px",
                    }}
                >
                    <div className="col">
                        <button
                            className="btn BackImga"
                            onClick={(e) => {
                                dispatch(settheTicketraiseroutes(0))
                                navigate("/internal_Dashboard");
                            }}
                        >
                            <img className="PreviousPages" src={BackImage} />
                            <span></span>
                        </button>
                    </div>
                </div>



                <div
                    className="row Filters"
                    style={{
                        padding: "29px 28px 57px",
                        margin: "0px",
                        position: "relative",
                        zIndex: "90",

                        marginLeft: "0px",
                        marginRight: "0px",
                        top: "-17px",
                    }}
                >
                    <div
                        className="col-sm-2"
                        style={{ marginTop: "-19px", zIndex: "99" }}
                    >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            State
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}

                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            onremoved={(e) => {
                                setMuliselect({ value: "", label: "All" });
                                console.log(e, "jjk9090");
                            }}
                            value={multiselect}
                            labelledBy="Select"
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Region
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
      isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}                            onremoved={(e) => {
                                setMuliselect1(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Zone
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
       isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}                            onremoved={(e) => {
                                setMuliselect3(e);
                                console.log(e, "jjk9090");
                            }}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div>





                </div>


                <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
                    <ReactTable
                        data={state.NeadueInternalTicketCalls.TicketingInternalNearduedata}
                        columns={columns}
                        totalItems={state.NeadueInternalTicketCalls.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        datacount={state.NeadueInternalTicketCalls.Total_Count}
                        values={StatusTicket}
                        options={optionsstatus}
                        ApproveRequestFilter={true}
                        Filter={Filter}
                        count={count}
                        ClearState={ClearState}
                        placeHold={"All"}
                        MakeCreate={true}
                        ViewParts={(e) => {
                            HandleTicketViewparts(e);
                        }}
                        PriorityKeys={true}
                        HandlethepriorityChanges={HandlethepriorityChanges}
                        priorityoptions={priorityoptions}
                        PriorityValues={PriorityValues}
                        Nodatarecord={"No Nearing Due Available"}

                    />

                </div>
            </div>
        </>
    );
};

export default NearDueListed;


